import { useContext } from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import './App.css';
import { AuthContext } from './authContext/AuthContext';
import Dashboard from './components/dashboard/Dashboard';
import Employees from './components/employees/Employees';
import EmployeesStats from './components/employees_stats/EmployeesStats';
import Jobs from './components/jobs/Jobs';
import Login from './components/login/Login';
import Machines from './components/machines/Machines';
import MachinesStates from './components/machines_stats/MachinesStates';
import Signup from './components/signup/Signup';
import 'react-loading-skeleton/dist/skeleton.css'

function App() {
  const {currentUser} = useContext(AuthContext)

  const RequiredRoute = ({children})=>{
    return currentUser ? children : <Navigate to='/login' />
  }

  return (
    <div>
      <BrowserRouter>
        <Routes>
           <Route path='/' element={<RequiredRoute><Dashboard /></RequiredRoute>} />
           <Route path='/login' element={<Login />} />
           <Route path='/signup' element={<Signup />} />
           <Route path='/jobs' element={<RequiredRoute><Jobs /> </RequiredRoute>} />
           <Route path='/employees' element={<RequiredRoute><Employees /></RequiredRoute>} />
           <Route path='/employees/stats' element={<RequiredRoute><EmployeesStats /></RequiredRoute>} />
           <Route path='/machines' element={<RequiredRoute><Machines /></RequiredRoute>} />
           <Route path='/machines/stats' element={<RequiredRoute><MachinesStates /></RequiredRoute>} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
